module.exports = __webpack_public_path__ + "img/blhsg03_center_002.8651c293.png";